import { Button, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetVerifyOtp } from '../../../redux/features/auth/VerifyOTP';
import { resetForgotPassword } from '../../../redux/features/auth/ForgotPassword';

interface props {
	disSuccessMdl: any;
	triggerSuccess: any;
	title: any;
	redirection: string;
}
const SuccessModel = ({ disSuccessMdl, triggerSuccess, redirection, title }: props) => {
	const navigate = useNavigate(),
		[openSuccessMdl, setOpenSuccessMdl] = useState<boolean>(true);
	const handleCancel = () => {
		triggerSuccess(false);
		setOpenSuccessMdl(false);
	};
	const dispatch = useDispatch();
	useEffect(() => {}, [disSuccessMdl]);
	return (
		<div>
			<Modal
				title={false}
				closable={false}
				maskClosable={false}
				open={openSuccessMdl}
				footer={false}
				width={500}
				onCancel={handleCancel}
				style={{ background: 'transparent', boxShadow: 'none' }}
			>
				<div className="ant-row ant-row-center">
					<img width={150} src="/assets/images/passwordRest.png" alt="Prowess" />
				</div>
				{title}
				<div
					className="ant-row ant-row-center"
					onClick={() => {
						if (redirection === 'login') {
							navigate('/');
						}
						dispatch(resetVerifyOtp());
						dispatch(resetForgotPassword());
						handleCancel();
					}}
				>
					<Button size="small" type="primary">
						BACK TO {redirection === 'login' ? 'LOGIN IN' : 'HOME'}
					</Button>
				</div>
			</Modal>
		</div>
	);
};
export default SuccessModel;
